/* tslint:disable */
/* eslint-disable */
/**
 * David Master Api
 * db: david-master
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the RegisterRequestDTO interface.
 */
export function instanceOfRegisterRequestDTO(value) {
    let isInstance = true;
    return isInstance;
}
export function RegisterRequestDTOFromJSON(json) {
    return RegisterRequestDTOFromJSONTyped(json, false);
}
export function RegisterRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'isAdmin': !exists(json, 'isAdmin') ? undefined : json['isAdmin'],
    };
}
export function RegisterRequestDTOToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'firstName': value.firstName,
        'lastName': value.lastName,
        'email': value.email,
        'isAdmin': value.isAdmin,
    };
}
